// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nvr-snapshot__label{align-items:center;background:rgba(0,0,0,.6);bottom:0;display:flex;font-size:12px;height:22px;padding-left:9px;position:absolute;width:100%}.nvr-snapshot--expanded{box-shadow:4px 0 2px -4px #000;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
